import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'roundPipe',
    standalone: false
})
export class RoundPipe implements PipeTransform {
  transform(input: number) {
    return Math.round(input);
  }
}
